import gsap from "gsap";

$(document).ready(function() {
    const openMoreButton = $('.small-cases-block .open-more');

    openMoreButton.on('click', function() {
        const hiddenBox = $(this).closest(".small-cases-block").find(".hidden-items");

        if($(this).hasClass('-open')) {
            $(this).removeClass('-open');
            closeHeroGallery(hiddenBox[0]);
        } else {
            $(this).addClass('-open');
            expandHeroGallery(hiddenBox[0]);
        }
    });
});

function expandHeroGallery(thisBox) {
    gsap.timeline()
        .to(thisBox, {
            duration: 1,
            delay: 0.1,
            height: "auto",
            ease: "power4.out"
        })
}

function closeHeroGallery(thisBox) {
    gsap.timeline()
        .to(thisBox, {
            delay: 0.1,
            duration: 1,
            ease: "power4.out",
            height: 0,
        })
}